import { z } from 'zod';
import { endpoint } from './endpoint.js';
import {
  AddOfferUnitsRequestSchema,
  AddOfferUnitsResponseSchema,
  OfferIdSchema,
  OfferUnitIdSchema,
  OfferUnitAllResponseSchema,
  OfferUnitFilterOptionsResponseSchema,
  OfferUnitListQuerySchema,
  OfferUnitListPageResponseSchema,
  UpdateOfferUnitRequestSchema,
  RemoveOfferUnitsRequestSchema,
} from '../schemas/offer-unit.js';

export const offerUnits = {
  list: endpoint(
    'GET',
    '/offers/:offerId/units',
    z.object({ offerId: OfferIdSchema }).merge(OfferUnitListQuerySchema),
    OfferUnitListPageResponseSchema,
  ),
  /**
   * Whole-offer affordances source: every unit of the offer, unpaginated and
   * unfiltered, used by the units-tab map overlay + "Pobierz specyfikacje"
   * bulk download.
   */
  listAll: endpoint(
    'GET',
    '/offers/:offerId/units/all',
    z.object({ offerId: OfferIdSchema }),
    OfferUnitAllResponseSchema,
  ),
  /**
   * Offer-scoped filter options: distinct filter values present among the
   * offer's units, used to populate the units-tab filter-panel dropdowns so
   * they reflect only this offer's inventory rather than the whole catalog.
   */
  filterOptions: endpoint(
    'GET',
    '/offers/:offerId/units/filter-options',
    z.object({ offerId: OfferIdSchema }),
    OfferUnitFilterOptionsResponseSchema,
  ),
  add: endpoint(
    'POST',
    '/offers/:offerId/units',
    z.object({ offerId: OfferIdSchema }).merge(AddOfferUnitsRequestSchema),
    AddOfferUnitsResponseSchema,
  ),
  update: endpoint(
    'PATCH',
    '/offers/:offerId/units/:unitId',
    z
      .object({
        offerId: OfferIdSchema,
        unitId: OfferUnitIdSchema,
      })
      .merge(UpdateOfferUnitRequestSchema),
    z.void(),
  ),
  remove: endpoint(
    'DELETE',
    '/offers/:offerId/units/:unitId',
    z.object({
      offerId: OfferIdSchema,
      unitId: OfferUnitIdSchema,
    }),
    z.void(),
  ),
  removeBatch: endpoint(
    'DELETE',
    '/offers/:offerId/units',
    z.object({ offerId: OfferIdSchema }).merge(RemoveOfferUnitsRequestSchema),
    z.void(),
  ),
};
